module.exports = __webpack_public_path__ + "img/xiaochengxuCode.09f9d93c.jpg";